import AbstractSessionModel from './AbstractSessionModel';
import StoreFieldInSession from '../decorators/StoreFieldInSession';
import Observable from '../decorators/Observable';
import Action from '../decorators/Action';

export default class CustomServicesList extends AbstractSessionModel {
  @StoreFieldInSession()
  @Observable()
  customExternalService: Array<{
    name: string;
    url: string;
  }> = [];

  modalServiceName = '';

  modalServiceUrl = '';

  constructor() {
    super();
  }

  @Action()
  setCustomExternalService(
    customExternalService: Array<{ name: string; url: string }>
  ) {
    this.customExternalService = customExternalService;
  }

  @Action()
  addCustomExternalService(name: string, url: string) {
    this.customExternalService.push({ name, url });
  }

  @Action()
  removeCustomExternalService(index: number) {
    this.customExternalService.splice(index, 1);
  }

  @Action()
  resetModalFormState() {
    this.modalServiceName = '';
    this.modalServiceUrl = '';
  }

  @Action()
  setModalServiceName(name: string) {
    this.modalServiceName = name;
  }

  @Action()
  setModalServiceUrl(url: string) {
    this.modalServiceUrl = url;
  }

  public getSessionKey() {
    return 'CustomServicesList';
  }
}
